import styles from "./BankCardList.module.scss";
import {
  BankCard,
  BankCardsPageData,
} from "../../../../../pages/admin-panels/bank-cards/BankCards";
import deleteIcon from "../../../../../assets/images/layouts/navigation-icons/X (1).svg";

interface BankCardListProps {
  cards: BankCard[];
  pageData: BankCardsPageData;
  onDeleteCard: (cardId: number) => void;
  translationData: any;
}

const BankCardList = ({
  cards,
  pageData,
  onDeleteCard,
  translationData,
}: BankCardListProps) => {
  const getCardTypeIcon = (cardType: string) => {
    switch (cardType?.toLowerCase()) {
      case "visa":
        return "VISA";
      case "mastercard":
        return "MC";
      default:
        return "CARD";
    }
  };

  if (cards.length === 0) {
    return (
      <div className={styles.empty_state}>
        <div className={styles.empty_icon}>💳</div>
        <p className={styles.empty_text}>
          {pageData?.no_cards_text ||
            translationData?.auth_no_cards ||
            "Hələ heç bir kart əlavə edilməyib"}
        </p>
      </div>
    );
  }

  return (
    <div className={styles.card_list_container}>
      <div className={styles.card_list}>
        {cards.map((card) => (
          <div key={card.id} className={styles.card_item}>
            <div className={styles.card_visual}>
              <div className={styles.card_top}>
                <div className={styles.card_chip}></div>
                <div className={styles.card_type_badge}>
                  {getCardTypeIcon(card.card_type)}
                </div>
              </div>
              <div className={styles.card_number}>{card.pan_masked}</div>
            </div>
            <button
              className={styles.delete_button}
              onClick={() => onDeleteCard(card.id)}
              title={pageData?.delete_btn || translationData?.auth_delete || "Sil"}
            >
              <img src={deleteIcon} alt="delete" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BankCardList;
